<template>
  <section class="w-100 d-flex flex-column justify-content-center align-items-center">
    <h1 class="font-weight-bold text-center">Thank you for using WiLLies English.</h1>
  </section>
</template>

<script>
  export default {
    name: 'Thanks'
  }
</script>
